<div class="modal-header justify-content-between">
    <h4 class="modal-title header-13">
      Configure Connection
    </h4>
    <div>
     <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
    </div>
  </div>
  
  <div [hidden]="isLoading" class="assets-detail">
    <div class="asset-title"> Global </div>
    <div class="cont-group rounded v-center p-3 mb-3" [ngClass]="{ 'active': isGlobal === 'true' }">
      <div class="d-flex">
        <div class="flex-grow-1 d-flex">
          <input type="radio" [(ngModel)]="isGlobal" id="global" value="true" (click)="onChange()" (keydown.enter)="onChange()">
          <label class="v-center mx-2" for="global"> Configure {{ getNames(label.toLowerCase()) }} for all assets </label>
        </div>


        <nz-select [(ngModel)]="globalConnection" nzPlaceHolder="Select connection *" nzShowSearch>
          <nz-option-group *ngFor="let group of options" [nzLabel]="group.label">
            <nz-option *ngFor="let option of group.options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
          </nz-option-group>
        </nz-select>
      </div>
    </div>
    
    <div class="asset-title"> Individual Assets </div>
    <div class="cont-group rounded v-center p-3" [ngClass]="{ 'active': isGlobal === 'false' }">
      <div class="d-flex">
        <div class="flex-grow-1 d-flex">
          <input type="radio" [(ngModel)]="isGlobal" id="individual" value="false" (change)="displayAssets(true)">
          <span class="flex-grow-1 px-2 cursor-pointer v-center" (click)="displayAssets()" (keydown)="displayAssets()"> Configure {{ getNames(label.toLowerCase()) }} per asset </span>
        </div>
        <mat-icon class="expand-icon cursor-pointer" (click)="displayAssets()" (keydown)="displayAssets()" [ngClass]="{ 'rotate': !showAssets }"> keyboard_arrow_up </mat-icon>
      </div>
      <div *ngIf="showAssets" class="assets-container">
        <div *ngFor="let asset of assets" class="d-flex mt-2">
          <span class="ml-35 w-35 asset text-truncate">
            {{ asset.displayName }} <span class="required-star">*</span>
          </span>
          <nz-select [(ngModel)]="asset.llmId" nzPlaceHolder="Select connection" nzShowSearch>
            <nz-option-group *ngFor="let group of options" [nzLabel]="group.label">
              <nz-option *ngFor="let option of group.options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
            </nz-option-group>
          </nz-select>
        </div>
        <p *ngIf="isGlobal === 'false'" class="required-hint mt-2">
          <span class="required-star">*</span> All assets must have a connection configured before saving.
        </p>
      </div>
    </div>

  </div>


  <div *ngIf="isLoading" class="assets-detail v-center my-3 mx-4">
    <app-loading></app-loading>
  </div>

  <div class="modal-footer border-0">
    <div class="d-flex justify-content-end">
      <button
        class="btn-accello-secondary mx-2 open-btn"
        (click)="activeModal.dismiss('Cross click')"
      >
        Cancel
      </button>
      <button
        class="btn-accello-primary-light open-btn"
        [disabled]="!canSave"
        (click)="save()"
      >
        Save
      </button>
    </div>
  </div>
  